import { Button } from 'baseui/button';
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { setAllData } from '../actions/userData';
import { FirebaseUserContext } from '../firebase/FirebaseUserContext';
import AuthUserContext from '../firebase/session/context';
import { ACCOUNT_LINK, ADMIN_PAGE_LINK } from './flows/linkConstants';

const ProfileDropdown = ({ setAllData }) => {
   const history = useHistory();
   let fb = useContext(FirebaseUserContext)
   let { authUser } = useContext(AuthUserContext);
   return <>
      <div>
         <Button style={{ width: '150px' }}
            onClick={() =>
               history.push(ACCOUNT_LINK)
            }
         >
            Account
            </Button>
      </div>
      <div>
         <Button style={{ width: '150px' }}
            onClick={() => {
               fb.signOut();
            }}
         >
            Log Out
            </Button>
      </div>
      <div>
         <Button style={{ width: '150px' }}
            onClick={() => {
               setAllData({ answers: {}, flows: {} });
            }}>
            Reset Account
            </Button>
      </div>

      {authUser?.claims?.admin === true ?
         <div>
            <Button style={{ width: '150px' }}
               onClick={() => {
                  history.push(ADMIN_PAGE_LINK);
               }}>
               Admin Portal
            </Button>
         </div>
         : undefined
      }
   </>;
}

export default connect(() => ({

}), { setAllData })(ProfileDropdown);